import * as actionTypes from '../actions/actionTypes';

const initialState = {
    total: 0,
    credits: 0,
    dealer_list: [],
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.DEALERS_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                dealer_list: []
            };
        case actionTypes.DEALERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                dealer_list: []
            };
        case actionTypes.DEALERS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                total: action.payload.count,
                credits: action.payload.credits,
                dealer_list: action.payload.data
            };
        default:
            return state;
    }
};

export default reducer;